import { manager } from './dialog-manager';

export { useDialog } from './dialog-hooks';
export { DialogRenderComponent } from './dialog-render-component';
export type { ReactDVFC } from './types';

export const createDialog = manager.createDialog;
